import { render, staticRenderFns } from "./patient-condition-editor.vue?vue&type=template&id=6b36ac5e&scoped=true&"
import script from "./patient-condition-editor.vue?vue&type=script&lang=js&"
export * from "./patient-condition-editor.vue?vue&type=script&lang=js&"
import style0 from "./patient-condition-editor.vue?vue&type=style&index=0&id=6b36ac5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b36ac5e",
  null
  
)

export default component.exports